import { render, staticRenderFns } from "./NetworkPage.vue?vue&type=template&id=5b6cfea4&scoped=true&"
import script from "./NetworkPage.vue?vue&type=script&lang=js&"
export * from "./NetworkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cfea4",
  null
  
)

export default component.exports